import {getImageAssetUrl} from '@/_application/core/utils/common';
import Logo from '@/_application/core/components/ui/logo';

function CompanyInfo() {
    const logoFooterUrl = getImageAssetUrl('images/logo-footer.png');
    return (
        <div className="text-[12px] lg:text-sm">
            <Logo
                logoProps={{
                    width: 224,
                    height: 84,
                    sizes: '100%',
                    title: 'KidsPlaza',
                    alt: 'KidsPlaza',
                }}
                logoUrl={logoFooterUrl}
            />
            <div className="py-3 text-xs leading-[25px]">
                <p>
                    <b>Đơn vị chủ quản:</b> Công ty Cổ phần Kids Plaza
                </p>
                <p>
                    <b>Địa chỉ:</b> 20 Thái Thịnh, Phường Đống Đa, Hà Nội
                </p>
                <p>
                    <b>Điện thoại:</b> (024) 7300 0088
                </p>
                <p>
                    <b>Email:</b> contact@kidsplaza.vn
                </p>
                <p>
                    <b>Mã số thuế / Mã số doanh nghiệp:</b> 0105330703
                </p>
                <p>do Sở KHĐT Hà Nội cấp ngày 26/05/2011.</p>
            </div>
        </div>
    );
}

export default CompanyInfo;
